import styled from "styled-components";
import { useNavigate } from "react-router";
import SessionService from "../../../../../../services/session-service";
import { theme } from "../../../../../../helpers/theme";
import { ReactComponent as ForkliftSVG } from "../../../../../../assets/icons/forklift.svg";
import Icon from "../../../../../../components/icon";
import { ViewVariantsTitle } from "../helpers/view-variants-title";
import { ViewVariantsArticle } from "../helpers/view-variants-article";
import { StyledButton } from "../../../../../../components/Button/button";


const title: string = "Nie masz dostępu do widoku ofert."
interface TokenAccessExpiredProps {
  notatka_konsultanta?: string;
  phone?: string;
  error_debug?:string;
}

export const TokenAccessExpired = ({ notatka_konsultanta, phone,error_debug }: TokenAccessExpiredProps) => {
  const navigate = useNavigate();
  //const loggedUserData = SessionService.getLoggedUserData();
  return (
    <ViewWrapper>
      <IconWrapper>
        <Icon
          width="153px"
          height="148px"
          icon={<ForkliftSVG />}
        />
      </IconWrapper>
      <ViewVariantsTitle
        title={error_debug?error_debug:title}
      />
      {/* <ViewVariantsArticle
        phone={loggedUserData.telefon ? loggedUserData.telefon : ""}
      /> */}
      <ButtonWrapper>
        <StyledButton
          onClick={() => navigate('/')}
        >Ok, rozumiem</StyledButton >
      </ButtonWrapper>
    </ViewWrapper>

  );
};

const ViewWrapper = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
`;
const IconWrapper = styled.div`
margin-left:auto;
margin-right:auto;
margin-top:48px;
`;
const ButtonWrapper = styled.div`
margin-left:auto;
margin-right:auto;
margin-bottom:40px;
margin-bottom:240px;
margin-top:26px;
`;

const OfferFormCreateWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //   @media (max-width: ) {
  //     margin-top: 0px;
  //   }
`;
const OfferFormCreateIconsWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const OfferFormCreateInfo = styled.span`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin: 0 10px;
`;
const OfferElipseBgWrapper = styled.div`
  position: absolute;
`;
